import React from 'react';
import loadable from '@loadable/component';

const Loading = () => <div>Loading....</div>;

export const baseLoader = (importState: () => any) => loadable(importState, { fallback: <Loading /> });
